<template>
  <div class="page">
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
        </div>
        <div class="icon-group">
          <span
            class="icon-box"
            @click="refreshMppLessonList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <el-table
        :data="tableList"
        width="100%"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        > </el-table-column>
        <el-table-column
          align="center"
          prop="tableName"
          label="表名称"
        > </el-table-column>
        <el-table-column
          align="center"
          label="表描述"
        >
          <template slot-scope="scop">
            <el-input
              v-model="scop.row.tableComment"
              placeholder="请输入内容"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div
                @click="generateTable(scop.row.tableName,scop.row.tableComment)"
                size="small"
              >
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看字段</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 查看表结构 -->
      <el-dialog
        :title="tableStates[tableState]"
        :visible.sync="showDialog"
        width="80%"
        @close="closeDialog"
      >
        <div>
          <el-table
            :data="columnList"
            row-key="id"
            @selection-change="handleSelectionChange"
            size="small"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            > </el-table-column>
            <el-table-column
              align="center"
              label="字段描述"
              width="100"
              size="small"
            >
              <template slot-scope="scop">
                <el-input
                  size="small"
                  v-model="scop.row.columnComment"
                  placeholder="请输入内容"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="columnName"
              label="字段名称"
              width="180"
              size="small"
            > </el-table-column>
            <el-table-column
              align="center"
              label="字段类型"
              width="120"
              size="small"
            >
              <template slot-scope="scop">
                <el-select
                  size="small"
                  v-model="scop.row.columnType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(value , index) in columnTypeList"
                    :label="value"
                    :key="index"
                    :value="value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="控件类型"
              width="150"
              size="small"
            >
              <template slot-scope="scop">
                <el-select
                  size="small"
                  v-model="scop.row.controlType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(value , index) in controlTypeList"
                    :label="value"
                    :key="index"
                    :value="value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="验证类型"
              width="150"
              size="small"
            >
              <template slot-scope="scop">
                <el-select
                  size="small"
                  v-model="scop.row.validationType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(value , index) in validationTypeList"
                    :label="value"
                    :key="index"
                    :value="value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="字段小写"
              width="180"
              prop="lowerPropertyName"
              size="small"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="upperPropertyName"
              label="字段大写"
              width="180"
              size="small"
            > </el-table-column>
          </el-table>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="generate"
            v-if="tableState == 'gen'"
          >生成代码</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetTableList();
                this.getTableList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetTableList();
                this.getTableList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                tableName: ''
            },
            table: {
                tableName: '',
                tableComment: ''
            },
            showDialog: false,
            loading: false,
            tableState: 'gen',
            tableStates: {
                gen: '查看字段'
            },
            multipleSelection: [],
            tableList: [], //所有表
            btnLoading: false,
            columnList: [], //表字段
            columnTypeList: [], //字段类型
            controlTypeList: [], //控件类型
            validationTypeList: [] //验证类型
        };
    },
    created() {
        this.getTableList();
    },
    methods: {
        resetTableList() {
            this.tablelist = [];
        },
        resetDialog() {
            this.showDialog = false;
            this.queryForm = {
                tableName: '' //表名称
            };
            this.getTableList();
        },
        closeDialog() {
            this.resetDialog();
            this.tableList = [];
            this.columnList = [];
            this.columnTypeList = [];
            this.controlTypeList = [];
            this.validationTypeList = [];
        },

        refreshMppLessonList() {
            this.resetTableList();
            this.getTableList();
        },
        //所有字段类型
        getColumnTypeList() {
            get(`/generator/findColunmTypes`, {}).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.columnTypeList = res.columnTypeList;
                }
            });
        },
        //查看所有控件类型
        getControlTypes() {
            get(`/generator/findControlTypes`, {}).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.controlTypeList = res.controlTypeList;
                }
            });
        },
        //验证类型
        getValidationTypes() {
            get(`/generator/findValidationTypes`, {}).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.validationTypeList = res.validationTypeList;
                }
            });
        },
        //查看所有表
        getTableList() {
            this.loading = true;
            get(`/generator/findTables`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.tableList = res.tablelist;
                }
            });
        },
        // 查看字段
        generateTable(tableName, tableComment) {
            this.showDialog = true;
            this.tableState = 'gen';
            this.table.tableName = tableName;
            this.table.tableComment = tableComment;
            get(`/generator/findColumns`, { tableName: tableName }).then((res) => {
                if (res.success) {
                    this.columnList = res.columnList;
                }
            });
            this.getColumnTypeList();
            this.getControlTypes();
            this.getValidationTypes();
        },
        //生成代码
        generate() {
            post(`/generator/generate`, {
                tableName: this.table.tableName,
                tableComment: this.table.tableComment,
                columnListJson: JSON.stringify(this.columnList)
            }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetDialog();
                }
            });
        },
        handleSelectionChange(value) {
            this.multipleSelection = value;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
